import React, { Suspense, useRef } from 'react';
import { createPageContextLogger, initWebLogger } from '@/common/log';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { RootSiblingParent } from 'react-native-root-siblings';
import { setPageProps } from '@kibt/krn-utils';
import { useConstructor } from './hooks/useLifecycle';
import { Platform } from 'react-native';
import './common/init-request';
import { PageContextProvider } from './common/context/pageContext';
import { $isRtl, initK18n } from './common/i18n';
import { setAppProps } from './AppProps';
import 'react-native-gesture-handler/createHandler';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ROUTER } from '@/router';
import SeoContainer from '@/component/SeoContainer';
import { kpf, language } from './common/const';
import { setCookie } from '@kwr/utils-krn';
import { useHistory } from 'react-router-dom';
import { useGlobalStore } from '@/store/useGlobalStore';
import { useLoginStore } from '@/component/LoginSdk/store/useLoginStore';
import { setSameDomainCookie } from './common/device-info';

// 如果初始化即需要，就直接import
const LoginSdk = React.lazy(() => import('@/component/LoginSdk'));

function App() {
    const history = useHistory();
    useConstructor(() => {
        // 设置router
        useGlobalStore.setState({
            routerHistory: history,
        });
        useLoginStore.getState().getUserInfo();
    });
    function RouteWithSubRoutes(route) {
        const { path, component, ...rest } = route;
        return (
            <>
                <Route path={path} render={props => <route.component {...props} routes={route.routes} />} {...rest} />
            </>
        );
    }
    return (
        <Switch>
            <SeoContainer>
                <Suspense fallback={<></>}>
                    {ROUTER.map((route, i) => (
                        <RouteWithSubRoutes key={route.path} {...route} />
                    ))}
                </Suspense>
                {/*<Route path="*">*/}
                {/*    <NoMatch />*/}
                {/*</Route>*/}
                <Suspense fallback={<></>}>
                    <LoginSdk />
                </Suspense>
            </SeoContainer>
        </Switch>
    );
}

export default function CreateMpaPage() {
    const ComponentWithInit = props => {
        const initRef = useRef({ props, logger: null });

        useConstructor(() => {
            initK18n();
            // 初始化weblogger
            initWebLogger(props, {
                // pageMap: autoPvPageMap,// TOOD?????
            });

            setSameDomainCookie('kpf', kpf as string);
            setSameDomainCookie('lang', language);

            // 创建pageContext
            const pageContextLogger = createPageContextLogger();
            let allProps: any = props;
            if (Platform.OS !== 'web') {
            } else {
                allProps = props;
                const isRtl = $isRtl();
                document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
            }
            setPageProps(allProps);
            setAppProps(allProps);
            initRef.current = { props: allProps, logger: pageContextLogger };
        });

        return (
            <RootSiblingParent>
                <SafeAreaProvider>
                    <GestureHandlerRootView style={{"flex":1}}>
                        <PageContextProvider value={{ logger: initRef.current.logger }}>
                            {/*因为App中会设置router，所以Router组件需要放在此*/}
                            <Router basename="shop">
                                <App {...initRef.current.props} />
                            </Router>
                        </PageContextProvider>
                    </GestureHandlerRootView>
                </SafeAreaProvider>
            </RootSiblingParent>
        );
    };
    return () => ComponentWithInit;
}
